module.exports = __webpack_public_path__ + "media/images/themes/lemon_freshness/lemon-17a53c6e6c694f5e6a6d43c74359718e.png";